module.exports = __webpack_public_path__ + "img/slide-2.62251b1.webp";